import { useState } from "react";

export const usePopup = () => {
  const [showPopup, setShowPopup] = useState<string>("");
  const [popUpConfig, setPopupConfig] = useState({ bannerOnHover: true });

  const handleShowPopup = (showPopup: string, popUpConfig: any = {}) => {
    setShowPopup(showPopup);
    if (showPopup) {
      setPopupConfig(popUpConfig);
    }
  };

  return { showPopup, popUpConfig, handleShowPopup, setShowPopup };
};
